$(document).ready(function(){
    $(".product_sticky_a-mb .default-option").click(function(){
        $(this).parent().toggleClass("active");
    });

    $(".product_sticky_a-mb .option,.product_sticky_a .common-product-tabbar-item").click(function(){
        let target = $(this).data("target");
        $(this).addClass("active").siblings().removeClass("active");
        $(this).parent().removeClass("active");
        $("html, body").animate({
            scrollTop: $(`.product-tabbar-item[data-target="${target}"]`).offset().top - $('#SiteHeader').outerHeight(true) - $('product-sticky-form').outerHeight(true)
        }, 500);
        return false;
    });

    $(".alink-add-cart-banner").click(function(){
        $(".alink-add-cart-banner .content").hide();
        $(".alink-add-cart-banner .loding").removeClass("show-none");
        $("button[data-add-to-cart]").click();
    });
});